module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Copyright"
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Page_Break"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing__And__Page_Break"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "'Poor Richard'",
      "font-size": "1.50em"
    }
  }, [_vm._v("COPYRIGHTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Slay” copyright © 2023 by Esther M. Friesner")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Avarice and Vengeance” copyright © 2023 by Madeline Dau")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“The Princess Network” copyright © 2023 by Niall Spain")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Cold Fire of Manhattan” copyright © 2023 by Russell Hugh ")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("McConnell")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Duck, Duck, Dragon” copyright © 2023 by Grace Eliza Ashton")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Sheep Rarely Wear Gold” copyright © 2023 by Mike Jack Stoumbos")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“The Exposé” copyright © 2023 by Paul D. Smith")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Lord Bai and the Magic Pirate” copyright © 2023 by Jean Marie Ward")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Tatsu: Cryo Five” copyright © 2023 by Gerald Brandt")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“A King Arthur Dragon in Space Station 23’s Court” copyright © 2023 by Jeanne Cook & Vicki Küng")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Migration Season” copyright © 2023 by Larry Ivkovich")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Bone and Blood” copyright © 2023 by Barbara Campbell")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“The Breeding Habits of Dragons” copyright © 2023 by Journey Sloane")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“Gods in Chains” copyright © 2023 by Em McDermott")]), _vm._v(" "), _c('p', {
    staticClass: "P_CopyrightPage"
  }, [_vm._v("“The Left Hand of Giordino” copyright © 2023 by Auston Habershaw")]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal"
  }, [_c('div', {
    staticClass: "B_Box2",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Line_Spacing"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.67em"
    }
  }, [_vm._v("“Reenactment” copyright © 2023 by David B. Coe")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3509737a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0005.vue
// module id = 72
// module chunks = 0